/**
 * Invoices Received - Módulo para la gestión de facturas recibidas
 */
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
import 'select2';
import { getSpanishLanguage, moneyFormat, showNotification } from '@/helpers';
export class InvoicesReceived {
    constructor() {
        this.TABLE_ID = '#invoicesTable';
        this.dataTable = null;
        this.modalElement = null;
        this.bootstrapModal = null;
        this.emailSelectElement = null;
        // Almacenar IDs de facturas seleccionadas
        this.selectedInvoiceIds = new Set();
        this.handleSearchKeyDown = (e) => {
            // Solo procesar tecla ENTER
            if (e.key !== 'Enter') {
                return;
            }
            const searchField = e.target;
            const email = searchField.value.trim();
            // Validar que sea un email válido
            if (!email || !this.isValidEmail(email)) {
                // Mostrar indicación visual de error
                searchField.classList.add('is-invalid');
                setTimeout(() => {
                    searchField.classList.remove('is-invalid');
                }, 1000);
                return;
            }
            // Verificar que el email no exista ya
            const currentValues = this.emailSelectElement?.val();
            const emails = Array.isArray(currentValues) ? currentValues : [];
            if (emails.includes(email)) {
                // Email ya existe, limpiar campo
                searchField.value = '';
                return;
            }
            // Agregar el nuevo email manualmente
            if (this.emailSelectElement) {
                // Obtener el elemento select nativo
                const selectElement = this.emailSelectElement[0];
                // Crear el objeto de opción
                const newOption = new Option(email, email, true, true);
                selectElement.add(newOption);
                // Trigger change para actualizar Select2
                this.emailSelectElement.trigger('change');
                // Limpiar el campo de búsqueda
                searchField.value = '';
                // Validar después de agregar
                this.validateEmailRecipients();
            }
            // Prevenir comportamiento por defecto y propagación
            e.preventDefault();
            e.stopPropagation();
        };
        this.baseUrl = window.location.origin;
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeModule();
            });
        }
        else {
            this.initializeModule();
        }
    }
    initializeModule() {
        this.initializeTable();
        this.initializeEmailModal();
        this.setupEventListeners();
    }
    setupEventListeners() {
        // Escuchar cambios de tema para ajustar la tabla si es necesario
        window.addEventListener('theme-changed', () => {
            this.adjustTableForTheme();
        });
        $(document).on('click', '.send-files', (e) => {
            const uuid = $(e.currentTarget).data('uuid');
            $('#uuid').val(uuid);
            this.openEmailModal();
        });
        $(document).on('click', '#massiveDownload', (e) => this.handleMassiveDownload());
        // Checkbox de seleccionar todos
        $('#selectAllInvoices').on('change', () => {
            this.toggleAllRows();
        });
        // Delegación de eventos para checkboxes individuales
        $(document).on('change', `${this.TABLE_ID} tbody .invoice-checkbox`, (e) => {
            const checkbox = e.target;
            const invoiceId = $(checkbox).data('id');
            if (checkbox.checked) {
                this.selectedInvoiceIds.add(invoiceId);
            }
            else {
                this.selectedInvoiceIds.delete(invoiceId);
            }
            this.updateSelectAllCheckbox();
        });
        // Evento de dibujado de DataTable para restaurar estado de checkboxes
        $(this.TABLE_ID).on('draw.dt', () => {
            this.restoreCheckboxStates();
            this.updateSelectAllCheckbox();
        });
    }
    /**
     * Alterna la selección de todas las filas de la tabla
     */
    toggleAllRows() {
        const selectAllChecked = $('#selectAllInvoices').is(':checked');
        const table = $(this.TABLE_ID).DataTable();
        const rows = table.rows({ search: 'applied' }).nodes();
        $(rows).each((index, row) => {
            const checkbox = $(row).find('.invoice-checkbox');
            if (checkbox.length > 0) {
                const invoiceId = checkbox.data('id');
                checkbox.prop('checked', selectAllChecked);
                if (selectAllChecked) {
                    this.selectedInvoiceIds.add(invoiceId);
                }
                else {
                    this.selectedInvoiceIds.delete(invoiceId);
                }
            }
        });
    }
    /**
     * Restaura el estado de los checkboxes después de un redraw de DataTables
     */
    restoreCheckboxStates() {
        const table = $(this.TABLE_ID).DataTable();
        const rows = table.rows({ search: 'applied' }).nodes();
        $(rows).each((index, row) => {
            const checkbox = $(row).find('.invoice-checkbox');
            if (checkbox.length > 0) {
                const invoiceId = checkbox.data('id');
                checkbox.prop('checked', this.selectedInvoiceIds.has(invoiceId));
            }
        });
    }
    /**
     * Actualiza el estado del checkbox "seleccionar todos" basado en las filas visibles
     */
    updateSelectAllCheckbox() {
        const table = $(this.TABLE_ID).DataTable();
        const rows = table.rows({ search: 'applied' }).nodes();
        const totalRows = rows.length;
        let checkedRows = 0;
        $(rows).each((index, row) => {
            const checkbox = $(row).find('.invoice-checkbox');
            if (checkbox.length > 0 && checkbox.prop('checked')) {
                checkedRows++;
            }
        });
        if (totalRows === 0) {
            $('#selectAllInvoices').prop('checked', false);
            $('#selectAllInvoices').prop('indeterminate', false);
        }
        else if (checkedRows === 0) {
            $('#selectAllInvoices').prop('checked', false);
            $('#selectAllInvoices').prop('indeterminate', false);
        }
        else if (checkedRows === totalRows) {
            $('#selectAllInvoices').prop('checked', true);
            $('#selectAllInvoices').prop('indeterminate', false);
        }
        else {
            $('#selectAllInvoices').prop('checked', false);
            $('#selectAllInvoices').prop('indeterminate', true);
        }
    }
    /**
     * Obtiene los IDs de las facturas seleccionadas
     */
    getSelectedInvoices() {
        return Array.from(this.selectedInvoiceIds);
    }
    /**
     * Limpia todas las selecciones
     */
    clearSelection() {
        this.selectedInvoiceIds.clear();
        const table = $(this.TABLE_ID).DataTable();
        const rows = table.rows({ search: 'applied' }).nodes();
        $(rows).each((index, row) => {
            const checkbox = $(row).find('.invoice-checkbox');
            if (checkbox.length > 0) {
                checkbox.prop('checked', false);
            }
        });
        $('#selectAllInvoices').prop('checked', false);
        $('#selectAllInvoices').prop('indeterminate', false);
    }
    initializeEmailModal() {
        this.modalElement = document.getElementById('sendMultipleEmailsModal');
        if (!this.modalElement) {
            console.warn('Email modal element not found');
            return;
        }
        // Inicializar el modal de Bootstrap
        if (window.bootstrap) {
            this.bootstrapModal = new window.bootstrap.Modal(this.modalElement);
        }
        // Inicializar Select2 para el campo de emails
        this.initializeEmailSelect();
    }
    initializeEmailSelect() {
        const emailSelect = $('#emailRecipients');
        if (emailSelect.length === 0) {
            console.warn('Email select element not found');
            return;
        }
        this.emailSelectElement = emailSelect.select2({
            theme: 'bootstrap-5',
            width: '100%',
            placeholder: 'Ingrese correos electrónicos y presione Enter',
            tags: true,
            // NO usar tokenSeparators para evitar creación automática con espacio o coma
            createTag: (params) => {
                // Siempre retornar null para prevenir creación automática
                // La creación se maneja manualmente con ENTER
                return null;
            }
        });
        // Escuchar cambios en el select para actualizar validación
        this.emailSelectElement.on('change', () => {
            this.validateEmailRecipients();
        });
        // Prevenir la creación automática de tags desde el dropdown
        this.emailSelectElement.on('select2:selecting', (e) => {
            const params = e.params.args.data;
            // Prevenir selección automática si no es un tag ya existente
            if (params && !params.selected) {
                e.preventDefault();
            }
        });
        // Manejar la tecla ENTER en el campo de búsqueda
        this.emailSelectElement.on('select2:open', () => {
            // Escuchar eventos de teclado en el campo de búsqueda
            setTimeout(() => {
                const searchField = document.querySelector('.select2-search__field');
                if (searchField) {
                    // Remover listeners anteriores si existen
                    searchField.removeEventListener('keydown', this.handleSearchKeyDown);
                    // Agregar nuevo listener para ENTER
                    searchField.addEventListener('keydown', this.handleSearchKeyDown);
                }
            }, 100);
        });
        // Limpiar listener cuando se cierra el dropdown
        this.emailSelectElement.on('select2:close', () => {
            const searchField = document.querySelector('.select2-search__field');
            if (searchField) {
                searchField.removeEventListener('keydown', this.handleSearchKeyDown);
            }
        });
    }
    openEmailModal() {
        if (this.bootstrapModal) {
            // Limpiar selecciones anteriores
            if (this.emailSelectElement) {
                this.emailSelectElement.val(null).trigger('change');
            }
            this.bootstrapModal.show();
        }
    }
    async handleMassiveDownload() {
        if (this.selectedInvoiceIds.size == 0)
            return;
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        const ids = Array.from(this.selectedInvoiceIds);
        const response = await fetch(`${this.baseUrl}/invoices_received/massive-download`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ids: ids,
                'csrf_token': csrfToken,
            }),
        });
        const { sended, url } = await response.json();
        if (url) {
            showNotification('Archivo generado correctamente', 'Verifica tu carpeta de descargas', 'success');
            window.location.href = url;
            return;
        }
        if (sended) {
            showNotification('Generando descarga masiva', 'Tu solicitud es demasiado grande, se te enviará un correo electrónico con el enlace para descargar el archivo una vez termine su procesamiento.', 'info');
        }
    }
    validateEmailRecipients() {
        const selectedEmails = this.emailSelectElement?.val();
        if (!selectedEmails || selectedEmails.length === 0) {
            this.showEmailError('Por favor, ingrese al menos un correo electrónico válido');
            return false;
        }
        // Verificar que todos los emails sean válidos
        const emails = Array.isArray(selectedEmails) ? selectedEmails : [selectedEmails];
        const invalidEmails = emails.filter((email) => !this.isValidEmail(email));
        if (invalidEmails.length > 0) {
            this.showEmailError(`Los siguientes correos no son válidos: ${invalidEmails.join(', ')}`);
            return false;
        }
        this.hideEmailError();
        return true;
    }
    showEmailError(message) {
        const errorElement = document.getElementById('emailRecipientsError');
        const selectElement = document.getElementById('emailRecipients');
        if (errorElement) {
            errorElement.textContent = message;
            errorElement.classList.remove('d-none');
        }
        if (selectElement) {
            selectElement.classList.add('is-invalid');
        }
    }
    hideEmailError() {
        const errorElement = document.getElementById('emailRecipientsError');
        const selectElement = document.getElementById('emailRecipients');
        if (errorElement) {
            errorElement.classList.add('d-none');
        }
        if (selectElement) {
            selectElement.classList.remove('is-invalid');
        }
    }
    isValidEmail(email) {
        if (!email || typeof email !== 'string') {
            return false;
        }
        // Expresión regular para validar email
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email.trim());
    }
    adjustTableForTheme() {
        // Ajustes visuales cuando cambia el tema (si es necesario)
        if (this.dataTable) {
            this.dataTable.draw(false);
        }
    }
    initializeTable() {
        const tableElement = document.querySelector(this.TABLE_ID);
        if (!tableElement) {
            console.warn('Invoices table element not found');
            return;
        }
        try {
            this.dataTable = $(this.TABLE_ID).DataTable(this.getTableConfig());
        }
        catch (error) {
            console.error('Error initializing DataTables:', error);
        }
    }
    getTableConfig() {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
        return {
            processing: true,
            serverSide: true,
            scrollX: true,
            language: getSpanishLanguage(),
            ajax: {
                url: `${this.baseUrl}/invoices_received/list`,
                type: 'POST',
                data: {
                    'csrf_token': csrfToken || ''
                },
                error: (xhr, error, thrown) => {
                    console.error('Error al cargar los datos:', error);
                    const tbody = document.querySelector(`${this.TABLE_ID} tbody`);
                    if (tbody) {
                        tbody.innerHTML = '<tr><td colspan="9" class="text-center text-danger">Error al cargar los datos. Por favor, recargue la página.</td></tr>';
                    }
                }
            },
            columns: [
                {
                    data: 'id_invoice_received',
                    name: 'id_invoice_received',
                    className: 'text-nowrap text-center',
                    render: (data) => {
                        return `
                            <input
                                type="checkbox"
                                class="invoice-checkbox"
                                data-id="${data}"
                            />
                        `;
                    }
                },
                {
                    data: 'id_invoice_received',
                    name: 'id_invoice_received',
                    className: 'text-nowrap',
                    render: (data, type, row) => this.renderAcciones(row)
                },
                {
                    data: 'date_invoice_received',
                    name: 'date_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'date_stamped_invoice_received',
                    name: 'date_stamped_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'serie_invoice_received',
                    name: 'serie_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'folio_invoice_received',
                    name: 'folio_invoice_received',
                    className: 'text-nowrap text-start'
                },
                {
                    data: 'issuer_invoice_received',
                    name: 'issuer_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'issuer_social_reason_invoice_received',
                    name: 'issuer_social_reason_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'subtotal_invoice_received',
                    name: 'subtotal_invoice_received',
                    className: 'text-nowrap',
                    render: (data) => moneyFormat(Number(data))
                },
                {
                    data: 'vat_t_invoice_received',
                    name: 'vat_t_invoice_received',
                    className: 'text-nowrap',
                    render: (data) => moneyFormat(Number(data))
                },
                {
                    data: 'total_invoice_received',
                    name: 'total_invoice_received',
                    className: 'text-nowrap',
                    render: (data) => moneyFormat(Number(data))
                },
                {
                    data: 'description_status',
                    name: 'description_status',
                    className: 'text-nowrap text-center'
                },
                {
                    data: 'uuid_invoice_received',
                    name: 'uuid_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'date_register_received',
                    name: 'date_register_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'currency_invoice_received',
                    name: 'currency_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'exchange_rate_invoice_received',
                    name: 'exchange_rate_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'type_invoice_received',
                    name: 'type_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'imp_pagado',
                    name: 'imp_pagado',
                    className: 'text-nowrap',
                    render: (data) => this.renderDebitPayment(data),
                },
                {
                    data: 'receiver_invoice_received',
                    name: 'receiver_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'social_reason_receiver_invoice_received',
                    name: 'social_reason_receiver_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'payment_method_invoice_received',
                    name: 'payment_method_invoice_received',
                    className: 'text-nowrap'
                },
                {
                    data: 'description_use_cfdi',
                    name: 'description_use_cfdi',
                    className: 'text-nowrap'
                },
                {
                    data: 'description_regime',
                    name: 'description_regime',
                    className: 'text-nowrap'
                },
                {
                    data: 'uuid',
                    name: 'uuid',
                    className: 'text-nowrap text-center',
                    render: (data) => this.renderComplemento(data),
                },
                {
                    data: 'black_list_invoice_received',
                    name: 'black_list_invoice_received',
                    className: 'text-nowrap text-center',
                    render: (data) => this.renderBlackList(data),
                },
                {
                    data: 'carta_porte_invoice_received',
                    name: 'carta_porte_invoice_received',
                    className: 'text-nowrap text-center',
                    render: (data) => this.renderCartaPorte(data),
                },
                {
                    data: 'purchase_order',
                    name: 'purchase_order',
                    className: 'text-nowrap text-center',
                },
            ],
            order: [{ name: 'date_invoice_received', dir: 'desc' }],
            pageLength: 25,
            lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]]
        };
    }
    renderComplemento(data) {
        return data || `
            <span
                class="badge bg-warning cursor-pointer"
                title="No hay comprobante de pago">
                <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
            </span>
        `;
    }
    renderBlackList(data) {
        if (!data)
            return data;
        const blackList = Number(data);
        return `
            <span
                class="badge bg-${blackList === 0 ? 'success' : 'danger'} cursor-pointer"
                title="${blackList === 0 ? 'No se encuentra en lista negra' : 'Se encuentra en lista negra'}">
                <i class="bi bi-${blackList === 0 ? 'check-circle' : 'exclamation-circle'}" aria-hidden="true"></i>
            </span>
        `;
    }
    renderCartaPorte(data) {
        if (!data)
            return data;
        const cartaPorte = Number(data);
        return `
            <span
                class="badge bg-info cursor-pointer"
                title="${cartaPorte === 0 ? 'No tiene carta porte' : 'Tiene carta porte'}">
                <i class="bi bi-${cartaPorte === 0 ? 'x-circle' : 'check-circle'}" aria-hidden="true"></i>
            </span>
        `;
    }
    renderDebitPayment(data) {
        return data ? moneyFormat(data) : '$0.00';
    }
    renderAcciones(row) {
        const { uuid_invoice_received: uuid, id_invoice_received: id, can_download_pdf, can_download_xml, can_download_validation, can_send_documents, can_edit_purchase_order, } = row;
        let buttons = `
            <div class="btn-group" role="group">
                ${can_download_pdf ? `
                        <a href="${this.baseUrl}/invoices_received/download-pdf/${uuid}"
                        class="btn btn-sm btn-outline-primary"
                        title="Descargar PDF">
                            <i class="bi bi-file-pdf"></i>
                        </a>` : ''}
                ${can_download_xml ? `
                        <a href="${this.baseUrl}/invoices_received/download-xml/${uuid}"
                        class="btn btn-sm btn-outline-primary"
                        title="Descargar XML">
                            <i class="bi bi-filetype-xml"></i>
                        </a>` : ''}
                ${can_download_validation ? `
                        <a href="${this.baseUrl}/invoices_received/download-validation/${uuid}"
                        class="btn btn-sm btn-outline-primary"
                        title="Descargar Validación">
                            <i class="bi bi-patch-check"></i>
                        </a>` : ''}
                ${can_send_documents ? `
                        <button
                            class="btn btn-sm btn-outline-primary send-files"
                            title="Enviar archivos"
                            data-uuid="${uuid}"
                        >
                            <i class="bi bi-send"></i>
                        </button>` : ''}
                ${can_edit_purchase_order ? `
                        <a href="${this.baseUrl}/invoices_received/edit-purchase-order/${id}"
                        class="btn btn-sm btn-outline-secondary"
                        title="Editar orden de compra">
                            <i class="bi bi-cart3"></i>
                        </a>` : ''}
        `;
        buttons += '</div>';
        ;
        return buttons;
    }
    /**
     * Obtiene la instancia del DataTable
     */
    getTable() {
        return this.dataTable;
    }
    /**
     * Recarga los datos de la tabla
     * @param resetPaging Si es true, resetea la paginación a la primera página
     */
    reload(resetPaging = false) {
        if (this.dataTable) {
            this.dataTable.ajax.reload(null, resetPaging);
        }
    }
    /**
     * Obtiene los datos seleccionados en la tabla
     */
    getSelectedRows() {
        if (this.dataTable) {
            return this.dataTable.rows('.selected').data().toArray();
        }
        return [];
    }
    /**
     * Filtra la tabla por una columna específica
     * @param column Índice de la columna
     * @param value Valor a buscar
     */
    filterByColumn(column, value) {
        if (this.dataTable) {
            this.dataTable.column(column).search(value).draw();
        }
    }
    /**
     * Limpia todos los filtros de la tabla
     */
    clearFilters() {
        if (this.dataTable) {
            this.dataTable.search('').columns().search('').draw();
        }
    }
}
export default InvoicesReceived;
